import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { faFileUpload, faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export interface UploadIconProps {
  /** When isUploading is true, displays a spinner. */
  isUploading: boolean;
}

export default function UploadIcon({ isUploading }: UploadIconProps) {
  if (isUploading) {
    return <FontAwesomeIcon spin={true} icon={faCircleNotch as IconProp} />;
  }

  return <FontAwesomeIcon icon={faFileUpload as IconProp} />;
}
